<template>
  <div class="image-style">
    <ul class="style editor-design">
      <li>画像</li>
      <!-- 画像未設定 -->
      <li v-if="isEmptyImage">画像を設定してください</li>
      <!-- 画像設定済 -->
      <template v-else>
        <!-- 揃え位置：イメージグループ以外で表示 -->
        <li class="editor-fields" v-if="showAlignAndMargins">
          <select-button
            :target="'margin'"
            :value="part.styles['margin'] || '0 auto'"
            @updateStyles="updateStyles($event)"
          />
        </li>
        <!-- 罫線 -->
        <li class="editor-fields">
          <select-border
            :type="'part'"
            :target="'border'"
            :value="part.styles['border-top']"
            @updateStyles="updateStyles($event)"
          />
        </li>
        <!-- 丸み -->
        <li class="flex-box">
          <range-border-radius
            :target="'border-radius'"
            :unit="'%'"
            :value="part.styles['border-radius']"
            :type="part.type"
            :attrs="part.attrs"
            @updateStyles="updateStyles($event)"
          />
        </li>
        <!-- 画像の余白：画像カードのみ -->
        <li v-if="showImageCardPadding">
          <slider
            :prop="'image-card-padding'"
            :value="part.styles['padding-top'] || part.styles['padding-right'] || part.styles['padding-bottom'] || part.styles['padding-left']"
            @updateStyles="updateImageCardPartPadding($event)"
          />
        </li>
      </template>
      <template v-if="showPaddingSlider">
        <!-- 上下余白 -->
        <li class="flex-box">
          <slider
            :prop="'padding-top'"
            :value="partsContainerStyles['padding-top']"
            @updateStyles="updatePartsContainerStyles($event)"
          />
        </li>
        <!-- 左右余白 -->
        <li class="flex-box">
          <slider
            :prop="'padding-right'"
            :value="partsContainerStyles['padding-right']"
            @updateStyles="updatePartsContainerStyles($event)"
          />
        </li>
      </template>
    </ul>
  </div>
</template>

<script>
import SelectBorder from '@/components/Content/Palette/CommonLayouts/EditStyleBorder'
import SelectButton from '@/components/Content/Palette/CommonLayouts/EditStyleSelectButton'
import RangeBorderRadius from '@/components/Content/Palette/CommonLayouts/EditStyleBorderRadius'
import ImagePartBase from '@/components/Content/ImagePartBase'
import Slider from '@/components/Content/Palette/CommonLayouts/EditStyleSlider'

export default {
  props: [
    'part',
    'ids',
    'partsContainerType',
    'partsContainerStyles',
  ],
  mixins: [
    ImagePartBase,
  ],
  components: {
    SelectBorder,
    SelectButton,
    RangeBorderRadius,
    Slider,
  },
  data () {
    return {
      sectionId: 0,
      partsContainerId: 0,
    }
  },
  computed: {
    // 余白のスライダー：画像 ロゴパーツのみ表示
    showPaddingSlider () {
      if (!this.partsContainerType) return null
      return this.partsContainerType === 'Image' || this.partsContainerType === 'Logo'
    },
    showImageCardPadding () {
      if (!this.partsContainerType) return null
      return this.partsContainerType === 'ImageCard'
    },
    isEmptyImage () {
      return this.part.attrs['data-key'] === null
    },
    // AlignとMarginsを表示するかどうか：画像グループのみ表示しない
    showAlignAndMargins () {
      return this.partsContainerType !== 'ImageGroup'
    },
  },
  methods: {
    initData () {
      this.sectionId = this.ids.sectionId
      this.partsContainerId = this.ids.partsContainerId
    },
    updateStyles (styles) {
      this.$store.dispatch('updateImageStyle', {
        ...this.ids,
        styles,
      })
    },
    updateImageCardPartPadding (value) {
      this.$store.dispatch('updateImageCardPartPadding', {
        sectionId: this.sectionId,
        partsContainerId: this.partsContainerId,
        partId: this.part.id,
        imagePosition: this.imagePosition,
        value,
      })
    },
    updatePartsContainerStyles (styles) {
      this.$store.dispatch('updateImagePartsContainerStyles', {
        sectionId: this.ids.sectionId,
        partsContainerId: this.ids.partsContainerId,
        styles,
      })
    },
  },
  beforeMount () {
    this.initData()
  },
  watch: {
    'ids.partsContainerId' () {
      this.initData()
    }
  }
}
</script>

<style lang="scss" scoped>
.editor-fields {
  display: flex;
  align-items: center;
  margin-bottom: 0;
  padding-bottom: 10px;
}
.flex-box:last-of-type {
  margin-bottom: 0;
  padding-bottom: 10px;
}
</style>

<style lang="scss">
.style.editor-design {
  .edit-style-border-radius {
    margin: 0;
  }
}
</style>
